import { FileOpenIcon } from 'ia-react-core';
import { FC, HTMLProps } from 'react';
import styled from 'styled-components';

export const StyledListItem = styled.li`
   margin-bottom:12px;
   margin-top:12px;
`;

export const StyledLink = styled.span`
  > a {
    color: ${({ theme }) => theme.colors.blue5};
  }
`;

export const StyledDownloadIconWrapper = styled.div`
  display: inline;
  > svg { width: 15px;
  height: 15px;
  position: absolute;
  margin-left: 3px;
  margin-top: 3px;
 }
`;

export const StyledAttachmentIcon = styled<FC<HTMLProps<SVGElement>>>(FileOpenIcon)`
  color: ${({ theme }) => theme.colors.blue5};
`;
